module.exports = __webpack_public_path__ + "img/headerCenterRight.c74bf499.png";